import axios from 'axios';
// config
import { HOST_API } from 'src/config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API });

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------

export const endpoints = {
  chat: '/api/chat',
  kanban: '/api/kanban',
  calendar: '/api/calendar',
  auth: {
    me: '/api/auth/me',
    login: '/api/auth/login',
    register: '/api/auth/register',
  },
  mail: {
    list: '/api/mail/list',
    details: '/api/mail/details',
    labels: '/api/mail/labels',
  },
  post: {
    list: '/api/post/list',
    details: '/api/post/details',
    latest: '/api/post/latest',
    search: '/api/post/search',
  },
  product: {
    list: '/api/product/list',
    details: '/api/product/details',
    search: '/api/product/search',
  },
  appointment: {
    create: '/public/appointments',
    update: '/public/appointments',
    delete: '/public/appointments',
    list: (userId) => `/public/appointments/${userId}`,
    listById: (id) => `/appointments/${id}`,
  },
  calculator: {
    create: (id) => `/public/appointments/${id}/lfcalculators`,
    list: (id, userId) => `/public/appointments/${id}/lfcalculators/${userId}`,
    update: (id) => `/public/lfcalculators/${id}`,
    delete: (id) => `/public/lfcalculators/${id}`,
    arrange: `/public/lfcalculators/positions`,
  },
};
